/* VATERSTIMME™ · SAT Akademie · Interaktives Deck
 * Quelle: Originalfolien Nenad Vladović · Korrekturen integriert
 * Stand: 3 Folien · weitere folgen */
export const vaterstimmeSlides = [
  // ── 1 · COVER ──────────────────────────────────────────────────────────
  {
    num: 1,
    type: "cover",
    title: "VATERSTIMME™",
    subtitle: "Durch Selbstermächtigung zur Vaterschaft in Würde und Selbstverantwortung.",
    intro:
      "Wir stärken Väter, damit sie in ihrer Kraft stehen, ihre Kinder bewusst begleiten und eine positive Zukunft für Familie und Gesellschaft gestalten.",
    pillars: [
      {
        h: "FÜR DICH",
        t: "Stärke deine Persönlichkeit, finde Klarheit und lebe deine Werte.",
      },
      {
        h: "FÜR DEINE KINDER",
        t: "Sei ein verlässlicher Halt und präge ihre Zukunft positiv.",
      },
      {
        h: "FÜR DEINE FAMILIE",
        t: "Schaffe Vertrauen, Harmonie und echte Verbindung.",
      },
      {
        h: "FÜR DIE ZUKUNFT",
        t: "Starke Väter schaffen starke Generationen und eine bessere Welt.",
      },
    ],
    tagline: "STARKE VÄTER · STARKE FAMILIEN · STARKE ZUKUNFT",
    closing: "Wir gehen den Weg gemeinsam.",
  },

  // ── 2 · WARUM VATERSTIMME ──────────────────────────────────────────────
  {
    num: 2,
    type: "content",
    kicker: "WARUM VATERSTIMME?",
    title: "Eine tiefe Sehnsucht — und eine ehrliche Verunsicherung.",
    subtitle: "Viele Männer spüren beides heute gleichzeitig.",
    bullets: [
      {
        h: "Orientierungslosigkeit",
        t: "Viele Männer wissen nicht, wie sie heute ihre Rolle als Vater leben sollen.",
      },
      {
        h: "Entfremdung",
        t: "Zu ihren Kindern, zu ihren Partnerinnen und oft auch zu sich selbst.",
      },
      {
        h: "Überforderung",
        t: "Zwischen Beruf, Familie, Erwartungen und dem Wunsch, ein guter Vater zu sein.",
      },
      {
        h: "Identitätskrise",
        t: "Traditionelle Rollenbilder brechen auf — neue Wege sind noch nicht klar.",
      },
      {
        h: "Gesellschaftlicher Wandel",
        t: "Unsere Kinder brauchen heute präsente, bewusste und starke Väter mehr denn je.",
      },
    ],
    mantra:
      "Ein starker Vater ist kein perfekter Vater. Ein starker Vater ist ein präsenter Vater.",
    mantraSub: "— Nenad Vladović",
    stats: [
      { v: "70 %", l: "der Kinder wünschen sich mehr Zeit mit ihrem Vater. (All Pro Dad)" },
      { v: "4×", l: "Kinder mit präsenten Vätern sind emotional stabiler. (Harvard Study)" },
      { v: "2×", l: "höhere Chance auf Schulerfolg bei aktiver Vater-Beteiligung. (US Dept. of Education)" },
      { v: "50 %", l: "weniger Risiko für Sucht, Gewalt und Kriminalität. (National Fatherhood Initiative)" },
      { v: "1", l: "Vater kann den Unterschied machen, der Generationen verändert." },
    ],
    cta: {
      title: "Werde die Stimme, die deine Kinder führt.",
      sub: "Für dich. Für deine Kinder. Für deine Familie. Für die Zukunft.",
    },
  },

  // ── 3 · DIE ROLLE DES VATERS ───────────────────────────────────────────
  {
    num: 3,
    type: "content",
    kicker: "DIE ROLLE DES VATERS",
    title: "Mehr als ein Versorger.",
    subtitle: "Er ist Wegweiser, Beschützer, Vorbild und Freund.",
    bullets: [
      {
        h: "Vorbild und Wegweiser",
        t: "Er zeigt durch sein Leben Werte, Integrität und Stärke.",
      },
      {
        h: "Sicherheit und Halt",
        t: "Er schafft Stabilität, Schutz und emotionale Sicherheit.",
      },
      {
        h: "Förderer und Ermöglicher",
        t: "Er ermutigt, fördert Talente und öffnet Türen.",
      },
      {
        h: "Grenzen und Orientierung",
        t: "Er setzt klare Grenzen und gibt Richtung im Leben.",
      },
      {
        h: "Verbinder der Generationen",
        t: "Er trägt Werte weiter und stärkt das Band zwischen Vergangenheit, Gegenwart und Zukunft.",
      },
    ],
    mantra:
      "Ein starker Vater prägt nicht nur das Leben seiner Kinder, sondern die Zukunft unserer Familien und unserer Gesellschaft.",
    side: {
      title: "Starke Väter. Starke Kinder. Starke Zukunft.",
      items: [
        "Gemeinsam erschaffen wir eine Welt,",
        "in der Kinder in Liebe, Respekt",
        "und Verantwortung aufwachsen.",
      ],
    },
  },
  // ── 4 · HERAUSFORDERUNGEN ──────────────────────────────────────────────
  {
    num: 4,
    type: "content",
    layout: "grid",
    kicker: "DIE HÄUFIGSTEN HERAUSFORDERUNGEN",
    title: "Viele Väter wollen das Beste — und stoßen dennoch an Grenzen.",
    subtitle:
      "Im Alltag begegnen ihnen Herausforderungen, die verunsichern und belasten.",
    bullets: [
      { h: "Entfremdung und Distanz", t: "Oft fällt es schwer, eine echte Verbindung zu den Kindern aufzubauen und zu halten." },
      { h: "Fehlende Vorbilder", t: "Viele Männer hatten selbst keinen starken Vater und suchen nach Orientierung." },
      { h: "Unsicherheit in der Rolle", t: "Viele Väter zweifeln, ob sie richtig sind und den Erwartungen gerecht werden." },
      { h: "Emotionale Belastung", t: "Innere Themen, Ängste und alte Prägungen belasten die Beziehung zu den Kindern." },
      { h: "Zeitmangel und Stress", t: "Beruf, Verpflichtungen und Alltag lassen kaum Raum für bewusste Vaterschaft." },
      { h: "Balance finden", t: "Die Balance zwischen Führung und Nähe, Freiheit und Grenzen ist eine Herausforderung." },
      { h: "Konflikte und Kommunikation", t: "Schwierigkeiten in der Kommunikation führen zu Missverständnissen und Spannungen." },
      { h: "Zukunft und Verantwortung", t: "Die Sorge, die Zukunft der Kinder positiv mitzugestalten, kann überwältigend sein." },
    ],
    mantra:
      "Die Herausforderungen von heute sind die Chancen für eine starke Vaterschaft von morgen.",
    cta: {
      title: "Du bist nicht allein",
      sub: "Jeder Vater steht vor Herausforderungen. Der Unterschied liegt darin, hinzuschauen und bewusst zu wachsen.",
    },
    badge: {
      title: "VATERSTIMME",
      lines: ["Unterstützung. Austausch. Wachstum.", "Für dich. Für deine Kinder. Für die Zukunft."],
    },
  },

  // ── 5 · DER SAT ANSATZ ─────────────────────────────────────────────────
  {
    num: 5,
    type: "content",
    layout: "wheel",
    kicker: "DER SAT ANSATZ",
    title: "Selbsterkenntnis · innere Arbeit · gelebte Vaterschaft.",
    subtitle:
      "VATERSTIMME basiert auf der ganzheitlichen SAT-Philosophie und verbindet drei Säulen für eine bewusste, starke und liebevolle Vaterschaft.",
    centerHub: "Bewusste Vaterschaft",
    bullets: [
      { h: "Selbsterkenntnis", t: "Sich selbst verstehen und annehmen." },
      { h: "Herzverbindung", t: "Eine tiefe Beziehung zu den Kindern aufbauen." },
      { h: "Verantwortung", t: "Verantwortung für sich, die Kinder und die Familie übernehmen." },
      { h: "Vorbild und Führung", t: "Ein gelebtes Vorbild sein und Orientierung geben." },
      { h: "Persönliches Wachstum", t: "Stärken entwickeln und über sich hinauswachsen." },
      { h: "Kommunikation und Verständnis", t: "Klar, wertschätzend und auf Augenhöhe kommunizieren." },
    ],
    cta: {
      title: "Unser Ziel",
      sub: "Väter stärken, damit Kinder in Liebe, Sicherheit und Freiheit aufwachsen und eine positive Zukunft gestalten können.",
    },
    side: {
      title: "Wirkung auf drei Ebenen",
      items: [
        "Auf mich — Ein erfülltes, authentisches und selbstbestimmtes Leben.",
        "Auf meine Familie — Mehr Harmonie, Vertrauen und echte Verbindung.",
        "Auf die Welt — Starke Familien schaffen eine bessere Gesellschaft und eine lebenswerte Zukunft.",
      ],
    },
    mantra:
      "Wir verändern nicht nur uns selbst. Wir verändern das Leben unserer Kinder — und damit die Zukunft unserer Welt.",
    mantraSub: "— Nenad Vladović",
    footerStrip: [
      { h: "Herz", t: "Fühlen" },
      { h: "Verstand", t: "Verstehen" },
      { h: "Handlung", t: "Umsetzen" },
      { h: "Veränderung", t: "Wirkung erzielen" },
    ],
    footerStripTitle:
      "Der SAT Ansatz ist tiefgehend, praxisnah und nachhaltig. Er verbindet Herz, Verstand und Handlung.",
  },

  // ── 6 · WAS WIR ANBIETEN ───────────────────────────────────────────────
  {
    num: 6,
    type: "content",
    layout: "grid",
    kicker: "WAS WIR ANBIETEN",
    title: "Praxisnahe Räume für Wachstum.",
    subtitle:
      "Sechs Angebote für Väter, die wachsen wollen — für sich, ihre Kinder und ihre Zukunft.",
    bullets: [
      {
        h: "Community · Gemeinsam statt allein",
        t: "Austausch · Unterstützung · ein starkes Netzwerk, das trägt.",
      },
      {
        h: "Gesprächsgruppen · Reden. Zuhören. Verstehen.",
        t: "Regelmäßige Treffen in geschütztem Rahmen, offene Gespräche, neue Perspektiven.",
      },
      {
        h: "Coaching · Individuell und verbindlich",
        t: "Persönliche Begleitung · Klarheit finden · Blockaden lösen · Ziele erreichen.",
      },
      {
        h: "Workshops · Wissen. Üben. Umsetzen.",
        t: "Praktische Tools, Kommunikation stärken, Vaterkompetenz entwickeln.",
      },
      {
        h: "Vater-Kinder-Aktivitäten · Zeit, die verbindet",
        t: "Gemeinsame Erlebnisse · Vertrauen vertiefen · Erinnerungen, die bleiben.",
      },
      {
        h: "Online-Bereich · Flexibel. Jederzeit. Überall.",
        t: "Videos, Impulse, Online-Kurse, Webinare und Zugang zur Community.",
      },
    ],
    cta: {
      title: "Mehr als Programme",
      sub: "Unsere Angebote sind Räume für Wachstum, Verbindung und echte Veränderung.",
    },
    mantra:
      "Wir begleiten Väter dabei, ihre Rolle bewusst zu leben, ihre Kinder zu stärken und ihre Zukunft positiv zu gestalten.",
    badge: {
      title: "VATERSTIMME",
      lines: ["Praxisnah. Authentisch. Wirksam.", "Für dich. Für deine Kinder. Für die Zukunft."],
    },
  },

  // ── 7 · UNSERE METHODEN ────────────────────────────────────────────────
  {
    num: 7,
    type: "content",
    layout: "grid",
    kicker: "UNSERE METHODEN",
    title: "Bewährtes Wissen · gelebte Praxis.",
    subtitle:
      "Wir kombinieren bewährte Methoden mit praktischer Erfahrung und echter Vaterschaft.",
    bullets: [
      { h: "Wissen", t: "Fundiertes Wissen für moderne Vaterschaft." },
      { h: "Austausch", t: "Erfahrungen teilen, voneinander lernen, gemeinsam wachsen." },
      { h: "Selbsterkenntnis", t: "Innere Klarheit gewinnen und an sich selbst arbeiten." },
      { h: "Praxisorientierung", t: "Konkrete Tools und Strategien für den Alltag." },
      { h: "Langfristige Wirkung", t: "Nachhaltige Veränderung für dich, deine Kinder und deine Familie." },
    ],
    secondary: {
      title: "Dein Weg mit uns",
      steps: [
        { h: "Orientieren", t: "Wo stehst du? Klarheit über deine aktuellen Themen und Ziele." },
        { h: "Verstehen", t: "Verstehen, was wirklich wichtig ist — für dich, deine Kinder und deine Familie." },
        { h: "Umsetzen", t: "Werkzeuge und Strategien anwenden, neue Gewohnheiten im Alltag integrieren." },
        { h: "Wachsen", t: "Kontinuierlich wachsen, Herausforderungen meistern, durchhalten und dranbleiben." },
        { h: "Wirken", t: "Ein starker Vater sein und eine positive Zukunft aktiv gestalten." },
      ],
    },
    mantra:
      "Methoden sind wichtig. Entscheidend ist aber, dass du ins Handeln kommst — jeden Tag ein Stück.",
    footerStrip: [
      { h: "Sicherer Rahmen", t: "Vertrauensvoller Raum für offene Gespräche." },
      { h: "Vertraulichkeit", t: "Deine Themen bleiben in geschütztem Rahmen — diskret und respektvoll." },
      { h: "Qualität", t: "Hochwertige Inhalte und praxisnahe Methoden von erfahrenen Experten." },
      { h: "Herz und Haltung", t: "Geprägt von Respekt, Authentizität und echtem Service." },
    ],
    badge: {
      title: "VATERSTIMME",
      lines: ["Methoden geben dir Werkzeuge. Deine Haltung macht den Unterschied."],
    },
  },

  // ── 8 · FÜR WEN IST DAS? ───────────────────────────────────────────────
  {
    num: 8,
    type: "content",
    layout: "grid",
    kicker: "FÜR WEN IST DAS?",
    title: "Für Väter, die mehr wollen.",
    subtitle:
      "Für sich. Für ihre Kinder. Für die Zukunft.",
    bullets: [
      {
        h: "Jeder Vater · Jede Lebensphase",
        t: "Egal ob jung oder erfahren — vom ersten Kind bis zum erwachsenen Kind. Deine Rolle zählt.",
      },
      {
        h: "Alle Familien-Konstellationen",
        t: "Verheiratet, getrennt, alleinerziehend oder Patchwork. Was zählt, ist deine Bereitschaft, Verantwortung zu übernehmen.",
      },
      {
        h: "Berufstätige Väter",
        t: "Praktische Lösungen für Väter mit wenig Zeit. Integration in Beruf, Alltag und Familienleben.",
      },
      {
        h: "Väter mit Motivation",
        t: "Du musst nicht perfekt sein. Der erste Schritt ist entscheidend — wir gehen ihn gemeinsam.",
      },
    ],
    secondary: {
      title: "Was du mitbringst",
      steps: [
        { h: "Bereitschaft", t: "Der Wille, hinzuschauen und zu wachsen." },
        { h: "Offenheit", t: "Neue Perspektiven zulassen und lernen." },
        { h: "Zeit", t: "Kleine Zeitfenster reichen — Kontinuität macht den Unterschied." },
        { h: "Engagement", t: "Aktiv Verantwortung übernehmen und dranbleiben." },
      ],
    },
    mantra:
      "Es spielt keine Rolle, wo du heute stehst. Es geht darum, wohin du gehen willst — und den ersten Schritt zu gehen.",
    cta: {
      title: "Jeder Vater. Jede Geschichte. Ein Ziel.",
      sub: "Starke Väter. Starke Kinder. Starke Zukunft.",
    },
    badge: {
      title: "VATERSTIMME",
      lines: ["Es geht nicht um Perfektion. Es geht um Präsenz, Liebe und echte Verantwortung."],
    },
  },
  // ── 9 · DEIN ERBE ALS VATER ────────────────────────────────────────────
  {
    num: 9,
    type: "content",
    layout: "grid",
    kicker: "DEIN ERBE ALS VATER",
    title: "Was bleibt, wenn du gehst?",
    subtitle: "Am Ende zählt nicht, was du besitzt — sondern was von dir bleibt.",
    intro:
      "Dein Erbe lebt in deinen Kindern, in deinem Vorbild und in deiner Wirkung weiter.",
    bullets: [
      {
        h: "Deine Kinder · Dein größtes Erbe",
        items: [
          "Sie lernen durch dein Vorbild, nicht durch deine Worte.",
          "Deine Werte prägen ihren Charakter.",
          "Deine Liebe gibt ihnen Wurzeln und Flügel.",
        ],
      },
      {
        h: "Dein Vermächtnis · Deine Werte bleiben",
        items: [
          "Integrität, Respekt und Verantwortung leben in ihnen weiter.",
          "Die Entscheidungen von heute formen die Generation von morgen.",
          "Ein starkes Fundament trägt weit.",
        ],
      },
      {
        h: "Deine Wirkung · Über dich hinaus",
        items: [
          "Deine Wirkung endet nicht bei dir.",
          "Sie berührt Familien, Gemeinschaften und die Gesellschaft.",
          "Ein bewusster Vater verändert mehr, als er sich vorstellen kann.",
        ],
      },
    ],
    secondary: {
      title: "5 Fragen für dein Erbe",
      steps: [
        { h: "Werte", t: "Welche Werte sollen meine Kinder von mir übernehmen?" },
        { h: "Erinnerung", t: "Wofür soll man sich an mich erinnern?" },
        { h: "Spuren", t: "Welche Spuren möchte ich in ihrer Kindheit hinterlassen?" },
        { h: "Vorbild", t: "Welche Art von Vater möchte ich gewesen sein?" },
        { h: "Wirkung", t: "Welche Wirkung möchte ich in der Welt hinterlassen?" },
      ],
    },
    mantra:
      "Dein Erbe ist nicht das, was du sammelst. Es ist das, was du weitergibst. Es ist das, was in ihnen weiterlebt.",
    cta: {
      title: "Dein Erbe beginnt heute — nicht irgendwann",
      sub: "Jeder bewusste Moment mit deinen Kindern ist ein Baustein für ihre Zukunft und dein Vermächtnis.",
    },
    badge: {
      title: "VATERSTIMME",
      lines: [
        "Dein Leben erzählt eine Geschichte.",
        "Sorge dafür, dass es eine ist, auf die deine Kinder stolz sind.",
      ],
    },
  },

  // ── 10 · VOM ICH ZUM WIR ───────────────────────────────────────────────
  {
    num: 10,
    type: "content",
    layout: "grid",
    kicker: "VOM ICH ZUM WIR — FÜR DIE ZUKUNFT",
    title: "Wahre Vaterschaft denkt über Generationen hinaus.",
    subtitle:
      "Wir bauen heute die Brücke für eine Welt, in der unsere Kinder frei, stark und verantwortungsvoll leben können.",
    bullets: [
      {
        h: "Zukunftsfähige Väter · Heute wachsen, morgen führen",
        items: [
          "Wir entwickeln uns kontinuierlich weiter.",
          "Wir bleiben offen für Neues.",
          "Wir übernehmen Verantwortung — für uns und andere.",
        ],
      },
      {
        h: "Starke Kinder · Geborgen. Befähigt. Bereit.",
        items: [
          "Sie erfahren Liebe und klare Führung.",
          "Sie lernen Werte nicht nur kennen, sondern leben sie.",
          "Sie werden ermutigt, ihren eigenen Weg zu gehen.",
        ],
      },
      {
        h: "Eine bessere Welt · Von Familie zu Gesellschaft",
        items: [
          "Starke Familien bilden das Fundament einer starken Gesellschaft.",
          "Verantwortungsvolle Väter schaffen positive Veränderungen.",
          "Gemeinsam gestalten wir eine Zukunft, auf die wir stolz sein können.",
        ],
      },
    ],
    secondary: {
      title: "Unser gemeinsames Versprechen",
      steps: [
        { h: "Wir leben vor", t: "Wir sind das Vorbild, das unsere Kinder brauchen." },
        { h: "Wir halten zusammen", t: "Wir unterstützen uns als Väter und gehen den Weg gemeinsam." },
        { h: "Wir bleiben lernend", t: "Wir sind nie am Ziel — wir bleiben neugierig und offen." },
        { h: "Wir handeln jetzt", t: "Nicht irgendwann. Heute ist der Tag, an dem wir beginnen." },
        { h: "Wir schützen und stärken", t: "Wir schaffen Räume der Sicherheit, des Vertrauens und des Wachstums." },
      ],
    },
    mantra:
      "Die Zukunft ist nicht etwas, das passiert — sie ist etwas, das wir gemeinsam gestalten.",
    mantraSub: "— VATERSTIMME",
    side: {
      title: "Die Reise der Vaterschaft",
      items: [
        "Hat kein Ende — aber jedes bewusste Kapitel macht den Unterschied.",
        "Bist du bereit?",
      ],
    },
    cta: {
      title: "Sei die VATERSTIMME",
      sub: "Die deine Kinder stärkt · die Generationen prägt · die die Zukunft gestaltet.",
    },
    badge: {
      title: "DEINE STIMME · DEINE VERANTWORTUNG · DEIN ERBE",
      lines: ["Für dich. Für deine Kinder. Für die Familie.", "Für die Gesellschaft. Für die Zukunft. Für Generationen."],
    },
  },

  // ── 11 · DIE ZUKUNFT BEGINNT HEUTE ─────────────────────────────────────
  {
    num: 11,
    type: "content",
    layout: "grid",
    kicker: "DIE ZUKUNFT BEGINNT HEUTE",
    title: "Die 6 Säulen deiner Vaterzukunft.",
    subtitle: "Vaterschaft ist eine Entscheidung — jeden Tag.",
    intro: "Die Zukunft deiner Kinder beginnt mit dem, was du heute tust.",
    bullets: [
      { h: "Liebe", t: "Liebe ist die Wurzel deiner Wirkung. Sie gibt Halt, Sicherheit und Zugehörigkeit." },
      { h: "Führung", t: "Führung beginnt bei dir. Sei ein Vorbild, an dem sich deine Kinder orientieren können." },
      { h: "Beziehung", t: "Echte Beziehung schafft Vertrauen. Vertrauen öffnet Herzen und ermöglicht Wachstum." },
      { h: "Entwicklung", t: "Fördere Talente, stärke Charakter und ermutige zum lebenslangen Wachstum." },
      { h: "Verantwortung", t: "Übernimm Verantwortung — für dich, deine Kinder und die Welt, die ihr gestaltet." },
      { h: "Vermächtnis", t: "Dein Vermächtnis sind nicht Worte, sondern gelebte Werte und bleibende Spuren." },
    ],
    secondary: {
      title: "5 tägliche Gewohnheiten starker Väter",
      steps: [
        { h: "Präsent sein", t: "Sei wirklich da — mit voller Aufmerksamkeit und offenem Herzen." },
        { h: "Zuhören", t: "Höre aktiv zu. Zeige Interesse und stelle Fragen." },
        { h: "Bestärken", t: "Ermutige deine Kinder. Feiere Fortschritte und stärke ihr Selbstvertrauen." },
        { h: "Grenzen setzen", t: "Gib klare Orientierung. Grenzen schaffen Sicherheit und Freiheit zum Wachsen." },
        { h: "Vorbild sein", t: "Lebe, was dir wichtig ist. Deine Kinder folgen deinem Beispiel, nicht deinen Worten." },
      ],
    },
    mantra:
      "Die beste Zeit, ein starker Vater zu werden, war gestern. Die zweitbeste Zeit ist jetzt. Entscheide dich. Für dich. Für deine Kinder. Für die Zukunft.",
    cta: {
      title: "Du musst nicht perfekt sein",
      sub: "Du musst nur bereit sein, jeden Tag ein bisschen besser zu werden.",
    },
    badge: {
      title: "VATERSTIMME",
      lines: [
        "Heute ist der erste Tag deines Erbes. Dein Einfluss ist zeitlos.",
        "Sei der Vater, den deine Kinder brauchen. Sei der Mann, der die Zukunft gestaltet.",
      ],
    },
  },

  // ── 12 · FINALE · DEIN WEG · DEIN ERBE · DEINE SPUREN ──────────────────
  {
    num: 12,
    type: "content",
    layout: "path",
    kicker: "DEIN WEG · DEIN ERBE · DEINE SPUREN",
    title: "Vaterschaft ist eine Reise — kein Endpunkt.",
    subtitle: "Dein Weg als Vater ist einzigartig. Aber du gehst nicht allein.",
    bullets: [
      { h: "Reflektieren", t: "Nimm dir regelmäßig Zeit, um innezuhalten und deinen Weg zu überprüfen." },
      { h: "Anpassen", t: "Sei bereit, dich weiterzuentwickeln und neue Wege zu gehen." },
      { h: "Verbinden", t: "Pflege die Beziehung zu deinen Kindern — jeden Tag ein bisschen mehr." },
      { h: "Vorleben", t: "Dein Leben ist das größte Vorbild. Sei der Mann, von dem sie lernen." },
      { h: "Investieren", t: "Investiere Zeit, Liebe und Energie — das ist deine größte Rendite." },
      { h: "Weitergeben", t: "Gib Werte, Weisheit und Wurzeln weiter — für Generationen, die kommen." },
    ],
    checklist: {
      title: "Deine tägliche Checkliste",
      items: [
        "Habe ich heute präsente Zeit mit meinen Kindern verbracht?",
        "Habe ich ihnen zugehört und sie wirklich gesehen?",
        "Habe ich Werte und Grenzen klar kommuniziert?",
        "Habe ich mein Verhalten vorgelebt, auf das ich stolz bin?",
        "Habe ich sie ermutigt und bestärkt?",
        "Habe ich Dankbarkeit gezeigt?",
        "Habe ich Liebe ausgedrückt?",
        "Bin ich heute ein Stück gewachsen?",
      ],
      note: "Kleine tägliche Entscheidungen formen ein starkes Erbe.",
    },
    mantra:
      "Deine Kinder erinnern sich nicht an das, was du ihnen gegeben hast — sondern an das, was du für sie warst.",
    mantraSub: "— Unbekannt",
    cta: {
      title: "Dein nächster Schritt",
      sub: "Wähle heute eine Sache aus dieser Präsentation, die du umsetzen wirst. Starte jetzt. Für dich. Für deine Kinder. Für die Zukunft.",
    },
    badge: {
      title: "VATERSTIMME",
      lines: [
        "Dein Erbe ist nicht, was du besitzt.",
        "Dein Erbe ist, was in deinem Kind weiterlebt.",
        "Sei der Vater, der Spuren hinterlässt.",
      ],
    },
  },
];

export default vaterstimmeSlides;
